import React, { useEffect } from 'react';
import Button from '@atlaskit/button';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import config from 'appconfig';
import t from 'modules/i18n/intl';
import { setSwitchUserEmail } from 'modules/mac/duck/actions/configUser';
import { selectIsMemberOfGroup, selectSwitchedUser } from 'modules/mac/duck/selectors';
import { fetchConsentHubLink } from 'modules/mac/duck/actions/consentHub';
import { selectConsentHubLink } from 'modules/mac/duck/selectors/consentHub';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  font-size: smaller;
`;

export const TopMenuMAC = () => {
  const dispatch = useDispatch();
  const userEmail = useSelector(selectSwitchedUser);
  const hasAccessToSwitchUserFunctionality = useSelector(selectIsMemberOfGroup);
  const consentHubLink = useSelector(selectConsentHubLink);

  useEffect(() => {
    if (consentHubLink) {
      const { preferencesCenterUrl } = consentHubLink;
      window.location.href = preferencesCenterUrl;
    }
  }, [consentHubLink]);

  return (
    <Wrapper data-cy="mac-header-line">
      {userEmail && (
        <Button appearance="link" href={config.emailMAC(userEmail)} data-cy="mac-header-line-email">
          {userEmail}
        </Button>
      )}
      <Button
        appearance="link"
        href={config.billingDetailsMAC}
        data-cy="mac-header-line-billing-details"
      >
        {t('mac.menu.billing-details')}
      </Button>
      {hasAccessToSwitchUserFunctionality ? (
        <Button appearance="link" href={config.switchUserMAC} data-cy="mac-header-line-switch-user">
          {t('mac.menu.switch-user')}
        </Button>
      ) : null}
      <Button
        appearance="link"
        onClick={() => {
          dispatch(fetchConsentHubLink());
        }}
        data-cy="mac-header-line-email-preferences"
      >
        {t('mac.menu.email-preferences')}
      </Button>
      <Button appearance="link" href={config.support} data-cy="mac-header-line-get-help">
        {t('mac.menu.get-help')}
      </Button>
      <Button appearance="link" href={config.marketplaceUrl} data-cy="mac-header-line-marketplace">
        {t('mac.menu.marketplace')}
      </Button>
      <Button
        appearance="link"
        href={config.switchAccountMAC}
        data-cy="mac-header-line-switch-account"
      >
        {t('mac.menu.switch-account')}
      </Button>
      <Button
        appearance="link"
        href={config.logOutMAC}
        onClick={() => dispatch(setSwitchUserEmail(''))}
        data-cy="mac-header-line-log-out"
      >
        {t('mac.menu.log-out')}
      </Button>
    </Wrapper>
  );
};
